<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<p style="margin-top: 150px;">For more information, please visit:</p><br/>
<p style="text-indent: 0em"><em>www.thehealingpowerofpain.com</em></p>
<p style="text-indent: 0em"><em>www.ybecasteleyn.be</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?fea56410